"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodeHATE = function CategoryCodeHATE(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodeHATE"), _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M12.857,3.477H3.143a.417.417,0,0,0-.417.417v9.362a.416.416,0,0,0,.734.27l1.774-2.085a.415.415,0,0,1,.317-.146h7.306a.417.417,0,0,0,.417-.417V3.894A.417.417,0,0,0,12.857,3.477ZM9.33,7.1H8.676l-.118.935H9.33v.956H8.437l-.1.776H7.183l.1-.776H6.334l-.1.776H5.079l.1-.776H4.644V8.03H5.3L5.416,7.1H4.644V6.139h.893l.1-.775H6.791l-.1.775H7.64l.1-.775H8.9l-.1.775H9.33ZM10.9,9.847a.67.67,0,1,1,.67-.669A.669.669,0,0,1,10.9,9.847Zm.478-1.626h-.956l-.191-2.953h1.339Z"
  }), _react.default.createElement("polygon", {
    points: "6.454 8.03 7.402 8.03 7.52 7.095 6.573 7.095 6.454 8.03"
  }))));
};

var _default = CategoryCodeHATE;
exports.default = _default;